import { SensorCCActionType } from '../../actions/ActionType'

const initialState = {
    loading: false,
    objeckt:[]
}

type action = {
    type: string
    objeckt?: any
}

const SensorCCReducer = (state = initialState, action: action) => {
    switch (action.type) {
        case SensorCCActionType.SensorCC_INIT:
            return {
                ...state,
                objeckt:action.objeckt,
                loading: true
            }
        default:
            return state
    }
}

export default SensorCCReducer
